import BaseObject from '../../../../base/base_object';
import _ from '../../../../utils/underscore';
import Model from './three_d_touch_model';
import {SYSTEM_EVENTS} from '../../../../events/events';
import Event from '../../../../utils/event';
import {T3D_TOUCH} from './three_d_touch_consts';
import ServiceFactory from '../../../service_factory';
import {CashierSessionTypes} from "../../../../../../common/const/cashier-session-types";


class ThreeDTouch extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ThreeDTouch';

    _model = null;
    _HybridService = null;

    init(params) {

        super.init(params);

        this._model = Model.create(params);

        this._subscribe();
    }

    initFeatures(hybridSrv) {
        this._HybridService = hybridSrv;
        return this;
    }

    _subscribe() {
            Event.on(SYSTEM_EVENTS.ON_INIT_COMPLETE, this.initThreeDTouch, this);
            Event.on(SYSTEM_EVENTS.RECENTLY_PLAYED_GAMES_UPDATED, this.updateRecentlyPlayed, this);
    }

    _languageService() {
        return ServiceFactory.create().languageService();
    }
    _gamesInformationService() {
        return ServiceFactory.create().gamesInformationService();
    }

    initThreeDTouch() {
         this._getCurrectShourtcutsLaunchTxt()
            .then(shourtcutsLaunch => {
                this._HybridService.init3DTouchShourtcutsLaunch(JSON.stringify(shourtcutsLaunch));
            });
    }

    /**
     * get the Currect Shourtcuts Launch Text
     * translate the caption to the currect language.
     * @returns {Promise}
     */
    _getCurrectShourtcutsLaunchTxt() {
        return new Promise((resolve) => {

            let shourtcutsLaunch = this._model.getParams();

            let bResolve = true;
            let caption = '';

            for (let key in shourtcutsLaunch) {

                let shourtcutData = shourtcutsLaunch[key];
                caption = shourtcutData.caption;

                shourtcutData.caption = this._languageService().translation(caption);

                if (T3D_TOUCH.ACT_PLAY_GAME === shourtcutData.action) {

                    this._model.setShourtcutGameCaption(caption);
                    this._model.saveInitGameId(shourtcutData.val);
                    shourtcutData.val = this._model.getRecentlyPlayedGame();
                    bResolve = false;

                    this.getCurrectGameName(shourtcutData).then(data => {
                        const res = null !== data ? shourtcutsLaunch : null;
                        resolve(res);
                    });
                }
            }
            if (bResolve) {
                resolve(shourtcutsLaunch);
            }
        });
   }

    /**
     * get the current game name.
     * @param caption: example: {action: "PlayGame", caption: "Play {GAME_NAME}", val: "130043"}
     * @returns {Promise} example: {action: "PlayGame", caption: "Play Millionaire Genie", val: "130043"}
     */
    getCurrectGameName(shortcutData) {
        return new Promise((resolve) => {
            let gameType = Number(shortcutData.val);
            return this._gamesInformationService().getGamesInfo([gameType])
                .then(gamesInfo => {
                   if(undefined !== gamesInfo[gameType]) {
                        shortcutData.caption = shortcutData.caption.replace('{GAME_NAME}', gamesInfo[gameType].title);
                        resolve(shortcutData);
                    }else{
                         resolve(null);
                    }
                });
        });
    }

    /**
     * @param action:  example: Login,QuickDeposit
     * @param caption: example: Login,QuickDeposit
     * @example: updateShourtcut('QuickDeposit','QuickDeposit')
     * @returns {Promise}
     */
    updateShourtcut(action, caption) {

        let shourtcutData = this._model.getUpdateShortcutDataObj(action, caption, '');
        this._HybridService.update3DTouchShortcut(shourtcutData);
    }


    /**
     * @param gameType: example: 130043
     * @example: updateGameShourtcut('130043')
     * @returns {Promise}
     */
    updateGameShourtcut(gameType) {

        let caption = this._model.getShourtcutGameCaption();
        caption = this._languageService().translation(caption);
        let shourtcutData = JSON.parse(this._model.getUpdateShortcutDataObj(T3D_TOUCH.ACT_PLAY_GAME, caption, gameType));

        this.getCurrectGameName(shourtcutData).then(data => {
            if(null !== data) {
                this._HybridService.update3DTouchShortcut(JSON.stringify(data));
                this._model.saveRecentlyPlayedGame(gameType);
            }
        });
    }

    /**
     * @update the Recently Played game
     * @param gamesList:  example: [130090, 130037, 130071]
     */
    updateRecentlyPlayed(gamesList) {
        this._gamesInformationService().getGamesInfo(gamesList).then(() => {
            if (!_.isEmpty(gamesList[0])) {
                this.updateGameShourtcut(gamesList[0]);
            }
        });
    }


    /**
     * @run the currect action from the 3dTouch button
     * @param shourtcuts:  example: {action:'PlayGame',val:'130090'}
     */
    runAction(shourtcuts) {

        if (!_.isEmpty(shourtcuts)) {
            switch (shourtcuts.action) {
                case T3D_TOUCH.ACT_LOGIN:
                    window.CGP.openLoginForm();
                   break;
                case T3D_TOUCH.ACT_PLAY_GAME:
                    window.CGP.openGame({gametype: Number(shourtcuts.val), isReal: true});
                    break;
                case T3D_TOUCH.ACT_QUICK_DEPOSIT:
                    ServiceFactory.create().cashierProxyService().openCashier({
                        sessionType: CashierSessionTypes.QUICK_DEPOSIT
                    })
                    break;
                default:
                    /* Maybe should throw an exception */
                    break;
            }
        }
    }



    /**
     * Delete a specific shourtcuts from the 3Dtouch shortcuts
     * @param action:  example: Login,QuickDeposit,PlayGame
     * @returns {Promise}
     */
    deleteShortcut(action) {
        let data = this._model.getUpdateShortcutDataObj(action);
        return this._HybridService.delete3DTouchShourtcut(data);
    }

    /**
     * Delete all the shourtcuts from the 3Dtouch shortcuts
     * @returns {Promise}
     */
    deleteAllShourtcuts() {
        return this._HybridService.deleteAll3DTouchShourtcuts();
    }

    /**
     * @get the shourtcuts that was pressed on the 3Dtouch
     * @returns {Promise}
     */
    getShortcutLaunch() {
        return new Promise((resolve, reject) => {
            this._HybridService.get3DTouchShortcutLaunch().then(data => {
                 let shourtcuts = this._model.getShortcutLaunch(_.safeJSONandDecode(data));
                 resolve(shourtcuts);
             }).catch(() => {
                 reject();
            });
        });
    }

}
export default ThreeDTouch;
